<template>
  <el-select
    v-close-on-zoom
    :value="value"
    placeholder="exactly"
    class="operator-select"
    :disabled="disabled"
    @input="(operator) => updateOperator(operator)"
  >
    <el-option
      v-for="op in operators"
      :key="op.value"
      :label="op.label"
      :value="op.value"
    />
  </el-select>
</template>

<script>
export default {
  name: 'operator-select',
  props: {
    value: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      operators: [
        { value: 'LESS_THAN', label: '<' },
        { value: 'LESS_THAN_OR_EQUAL', label: '≤' },
        { value: 'EQUAL', label: '=' },
        { value: 'NOT_EQUAL', label: '≠' },
        { value: 'GREATER_THAN_OR_EQUAL', label: '≥' },
        { value: 'GREATER_THAN', label: '>' },
      ],
    };
  },
  methods: {
    updateOperator(operator) {
      this.$emit('input', operator);
    },
  },
};
</script>

<style scoped>
.operator-select {
    width: 60px;
}
</style>